import { useQuery } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

import { SlackWorkspaceRef } from "../SlackService";

import { slackQueryKeys } from "./slackQueryKeys";

/**
 * The channels the workspace's bot is a member of. Empty means the bot is in no channel right
 * now — never-invited and removed-from-every-channel look identical here.
 *
 * The listing route is admin-only, so callers who must not ask (read-only viewers) gate with
 * `enabled` rather than withholding the workspace.
 */
export function useSlackWorkspaceChannels(
  orgId: string | undefined,
  workspace: SlackWorkspaceRef,
  opts: { enabled: boolean },
) {
  const { slackService } = useDomainServices();
  const resolvedOrgId = useCurrentOrgId(orgId);

  return useQuery({
    queryKey: slackQueryKeys.workspaceChannels(resolvedOrgId, workspace),
    queryFn: ({ signal }) =>
      slackService.listWorkspaceChannels(workspace, resolvedOrgId, {
        abortSignal: signal,
      }),
    enabled: opts.enabled,
    staleTime: 30_000,
  });
}
